import React from 'react';
import './Seguridad.css';
import seguridadHero from '../../assets/Seguridad.png';

const Seguridad = () => {
  return (
    <section className="seguridad-container">
      {/* 🔹 Banner */}
      <div className="seguridad-hero">
       <div className="seguridad-hero-text">
        <h1>Seguridad y protección de datos</h1>
        <p>En Salvir nos tomamos la seguridad de tu información clínica con absoluta seriedad.</p>
          <p> <strong>No sabemos quiénes son tus pacientes: sus datos personales se guardan cifrados y en nuestras herramientas internas aparecen ocultos. Solo tú tienes el control.</strong></p>
           <p>Utilizamos tecnología de clase mundial y nos alineamos con los más altos estándares para garantizar que tus datos estén siempre protegidos. Nuestra prioridad es tu tranquilidad: mientras tú cuidas a tus pacientes, nosotros cuidamos tu información.</p>

        </div> 
        <img
            src={seguridadHero}
            alt="Profesional de la salud protegido por un escudo de seguridad"
            className="seguridad-hero-img"
        />
      </div>

      {/* 🔹 Contenido en tarjetas */}
      <div className="seguridad-cards-scroll">

        <div className="seguridad-card">
          <h2>Seguridad aprobada por la Secretaría de Salud</h2>
          <p>
            Como parte de la certificación NOM-024 de Salvir (certificado DGIS-CER-P-021-2026-10), la Dirección General de Información en Salud evaluó y aprobó nuestro Sistema de Gestión de Seguridad de la Información en Salud.
          </p>
          <p>
            <a
              href="http://www.dgis.salud.gob.mx/intercambio/certificados/DGIS-CER-P-021-2026-10_gobmx.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver certificado oficial ↗
            </a>
          </p>
        </div>

        <div className="seguridad-card">
          <h2>Protección y confidencialidad de los datos</h2>
          <p>
            En Salvir entendemos que la información clínica es altamente sensible. Por eso la protegemos en cada paso:
          </p>
          <ul>
            <li>HTTPS garantiza el cifrado en tránsito.</li>
            <li>Cookies seguras para mantener sesiones protegidas.</li>
            <li>Acceso restringido exclusivamente al profesional de salud.</li>
            <li>Nunca compartimos tu información con terceros.</li>
          </ul>
        </div>

        <div className="seguridad-card">
          <h2>Infraestructura confiable</h2>
          <p>
            Nuestra plataforma está alojada en <strong>AWS</strong> (Amazon Web Services), una de las infraestructuras en la nube más seguras del mundo.
          </p>
          <p><strong>AWS cuenta con múltiples certificaciones:</strong></p>
          <ul>
            <li>ISO 27001</li>
            <li>SOC 1, SOC 2 y SOC 3</li>
            <li>PCI DSS Nivel 1</li>
            <li>FISMA Moderate</li>
            <li>Sarbanes-Oxley (SOX)</li>
          </ul>
          <p>
            Aprovechamos herramientas de AWS para auditoría, respaldo y control.
          </p>
        </div>

        <div className="seguridad-card">
          <h2>Cifrado y respaldos</h2>
          <ul>
            <li>Datos personales de tus pacientes cifrados.</li>
            <li>Respaldos diarios automáticos.</li>
            <li>Segmentación por profesional para trazabilidad y control.</li>
          </ul>
        </div>

        <div className="seguridad-card">
          <h2>Autenticación y control de acceso</h2>
          <ul>
            <li>Acceso con credenciales únicas.</li>
            <li>Verificación de identidad antes de acceder a expedientes.</li>
            <li>Bitácora de actividad de tu cuenta.</li>
            <li>Protección contra registros automáticos (bots).</li>
          </ul>
        </div>

        <div className="seguridad-card">
          <h2>Compromiso con la normativa</h2>
          <p>
            Salvir está certificado conforme a la NOM-024-SSA3-2012 y su historia clínica cumple con la NOM-004-SSA3-2012. Contamos con aviso de privacidad tanto para profesionales de la salud como para sus pacientes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Seguridad;